module.exports = __webpack_public_path__ + "static/media/package_dev_ios_plain.1fbcebd6.svg";